import React from 'react';
import { Box, Alert } from '@mui/material';

interface RequirePermissionProps {
  check: boolean;
  featureName: string;
  children: React.ReactNode;
}

const RequirePermission: React.FC<RequirePermissionProps> = ({ check, featureName, children }) => {
  if (!check) {
    return (
      <Box p={3}>
        <Alert severity="error">
          You don't have permission to access {featureName}. Please contact your administrator.
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
};

export default RequirePermission;
